import {createAvatar} from "@dicebear/avatars";
import * as style from "@dicebear/big-smile";
import SVG from 'react-inlinesvg'

export default function RandomAvatar({seed, ...props}){
    const svg = createAvatar(style, {seed: seed});

    // return <SvgCss xml={svg} width="100%" height="100%" />;
    return <SVG {...props} src={svg} />;
}